<template>
	<div>
		<div class="hidden-xs-only">
			<div class="">
				<img src="../../assets/image/journalism/bg.png" class="width-100 h-500">
				<div class="fu h-500 d-flex-items-center d-flex-center">
					<div class="m-t-20">
						<div class="f-57 c-white d-flex-center">新闻详情</div>
						<div class="f-28 c-white d-flex-center m-t-10">NEWS DETAIL</div>
					</div>
				</div>
			</div>
			<div class="d-flex-center p-t-40 p-b-40 f-30 font-weight-bold c-00 bgc-white">
				{{info.title}}
			</div>
			<div class="d-flex-center p-t-40 p-b-40 f-20 c-99 bgc-white">
				{{info.create_time}}
			</div>
			<div class="d-flex-center bgc-white">
				<div class="width-70 d-flex-center m-t-40 m-b-40 f-20 c-33" v-html="info.maincontent">
				</div>
			</div>
		</div>
		<div class="hidden-sm-and-up">
			<div class="">
				<img src="../../assets/image/journalism/bg.png" class="width-100 h-300">
				<div class="fu1 h-300 d-flex-items-center d-flex-center">
					<div class="m-t-20">
						<div class="f-30 c-white d-flex-center">新闻详情</div>
						<div class="f-14 c-white d-flex-center m-t-10">NEWS DETAIL</div>
					</div>
				</div>
			</div>
			<div class="d-flex-center p-t-20 p-b-20 f-30 font-weight-bold c-00 bgc-white">
				{{info.title}}
			</div>
			<div class="d-flex-center p-t-20 p-b-20 f-20 c-99 bgc-white">
				{{info.create_time}}
			</div>
			<div class="d-flex-center bgc-white">
				<div class="width-70 d-flex-center m-t-40 m-b-40 f-20 c-33" v-html="info.maincontent">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Loading
	} from 'element-ui';
	export default {
		data() {
			return {
				info: {}
			}
		},
		mounted() {
			this.getinfo()
		},
		methods: {
			async getinfo() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const res = await this.$service.post({
					url: '/api/web/v1/app_get_news_info',
					data: {
						news_id: this.$route.query.news_id
					}
				})
				if (res.code === 1) {
					this.info = res.info;
					this.$nextTick(() => {
						loading.close();
					}, 2000);
				}
			},
		}
	}
</script>

<style scoped>
	.fu {
		position: relative;
		margin-top: -500px;
	}

	.fu1 {
		position: relative;
		margin-top: -300px;
	}
</style>
